import { useEffect } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { fetchCompanyAccount } from '../../reducks/sessions'
import { companyClassification, companyAcceptedTerms, selectCompanyActiveSubscription } from '../../selectors/company'
import {
  companyId,
  companyLiveOrDormant,
  companyDormant,
  companyPreLive,
  companyLive,
  loadingCompany,
  companyState,
} from '../../selectors/sessions'

const CurrentCompany = ({ companySlug, reduxDispatchFetchCompanyAccount, children, ...props }) => {
  useEffect(() => {
    reduxDispatchFetchCompanyAccount(companySlug)
  }, [companySlug, reduxDispatchFetchCompanyAccount])

  return children({ companySlug, ...props })
}

const mapStateToProps = createStructuredSelector({
  loadingCompany,
  companyLiveOrDormant,
  companyDormant,
  companyPreLive,
  companyLive,
  companyClassification,
  companyId,
  companyState,
  companyAcceptedTerms,
  companyActiveSubscription: selectCompanyActiveSubscription,
})

const mapDispatchToProps = {
  reduxDispatchFetchCompanyAccount: fetchCompanyAccount,
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentCompany)
